import { default as Breadcrumbs } from '@jetshop/ui/Breadcrumbs';
import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../Theme';

const StyledBreadcrumbs = styled(Breadcrumbs)`
  margin-bottom: 10px !important;
  justify-content: center;
  margin-top: 40px;
  li:last-child {
    &:after {
      display: none;
    }
  }
`;

const SimpleCategoryHeaderWrapper = styled('div')``;
const Inner = styled('div')`
  max-width: 50rem;
  margin: auto;
  text-align: center;
  padding: 0 2rem;
`;

const Title = styled('h1')`
  font-weight: 600;
  line-height: 90%;
  font-size: 30px;
  margin-bottom: 10px;
  z-index: 1;
  ${theme.below.lg} {
    font-size: 20px;
  }
`;

const ContentWrapper = styled('div')`
  font-weight: normal;
  max-width: 100%;
  line-height: 1.6;
  font-size: 14px;
`;

const Content = ({ category, breadcrumbProps }) => (
  <>
    <StyledBreadcrumbs {...breadcrumbProps} />
    <Title>{category.name}</Title>
    <ContentWrapper
      data-testid="category-description"
      dangerouslySetInnerHTML={{
        __html: category.content
      }}
    />
  </>
);

const CategoryHeader = ({ category, parents }) => {
  const breadcrumbProps = {
    breadcrumbText: category.breadcrumbText,
    parents
  };

  return (
    <>
      <SimpleCategoryHeaderWrapper>
        <Inner>
          <Content category={category} breadcrumbProps={breadcrumbProps} />
        </Inner>
      </SimpleCategoryHeaderWrapper>
    </>
  );
};

export default CategoryHeader;
